/**
 * Alaska: App.js (PWA)
 * Store: Overlay
 * @version 1.0
 */

document.addEventListener("alpine:init", () => {
    Alpine.store("overlay", {
        visible: false,
        type: "success",
        message: "This is a notification!",

        render(type = "success", message) {
            this.visible = true;
            this.type = type;
            this.message = message;

            setTimeout(() => {
                this.visible = false;
            }, 2500);
        }
    })
});